import React from 'react';
import { useSelector } from 'react-redux';

import Accordion from '../../Layout/Accordion';
import LoyalDeacHeart from './LoyalDeacHeart';

const LoyalDeac = () => {
  const loyalDeacInfo = useSelector(
    (state) => ((state.Profile || {}).BIOGRAPHICAL || {}).LOYALDEACDETAILS
  );

  const hearts = Object.keys(loyalDeacInfo || {}).map((key) => {
    // @TODO: Use LOYALDEAC.Status to add the sparkle SVG at the end
    if (key === 'LOYALDEAC') {
      return null;
    }

    const firstLetter = key.charAt(0);
    return (
      <LoyalDeacHeart
        letter={firstLetter}
        isFilled={loyalDeacInfo[key].Status === 'Active'}
        key={key}
      />
    );
  });

  return (
    <Accordion
      mTitle='My Loyal Deac Status'
      sTitleIcon='heart'
      sGtmCategory='Loyal Deac'
    >
      <div className='loyalDeac__panelContent'>
        <div className='loyalDeac__hearts'>{hearts}</div>
        <div className='loyalDeac__details'>
          <p className='loyalDeac__textHeader t-paragraph--large'>
            What is a Loyal DEAC?
          </p>
          <p className='loyalDeac__text'>
            Loyal DEACs are model citizens of the Wake Forest community who:
            Discover the power of the Wake Forest community, Engage in
            university events, Advocate for Wake as active volunteers and Commit
            to the long term success of Wake Forest by making a gift every year.
          </p>
          <p className='loyalDeac__text'>
            Thank you for being a Loyal DEAC! It&rsquo;s time to renew your
            status.{' '}
            <a
              href='https://loyaldeac.wfu.edu/'
              target='_blank'
              rel='noopener noreferrer'
            >
              Learn how today.
            </a>
          </p>
        </div>
      </div>
    </Accordion>
  );
};

export default LoyalDeac;
